/**
 * <Satisfaction> — a star rating, readonly or to tap (atom, L0.1).
 *
 * The maison equivalent of the legacy `SatisfactionComponent`: `max` stars, filled gold (`accent`,
 * the legacy `fillColor`) up to `rating` and grey (`border`) after. Kept vendor-free on purpose —
 * `@kolking/react-native-rating` loads its star asset via `require`, which breaks the Storybook web
 * bundle ("require is not defined"). Composes the `<Icon>` atom + `<Row>`. No hex.
 *
 * `onRate` en fait la note que l'élève donne à la fin de son live : chaque étoile presse et remonte
 * sa valeur. Absent (défaut) : les étoiles ne pressent pas, rendu inchangé.
 */
import React from "react"
import { Pressable } from "react-native"

import { Row } from "../containers/Row"
import { Icon } from "../icons/Icon"

export type SatisfactionProps = {
    /** Filled stars, 0–`max`. */
    rating: number
    /** Number of stars — defaults to 5. */
    max?: number
    /** Star size in px — defaults to 40 (legacy `imageSize`). */
    size?: number
    /** Une étoile touchée : la note qu'elle donne. Absent : la note se lit seulement. */
    onRate?: (rating: number) => void
    testID?: string
}

const starLabel = (value: number) => (value === 1 ? "1 étoile" : `${value} étoiles`)

export function Satisfaction(props: SatisfactionProps) {
    const { rating, max = 5, size = 40, onRate, testID } = props
    const stars = Array.from({ length: max }, (_, i) => i + 1)

    return (
        <Row gap="1" align="center" testID={testID}>
            {stars.map((i) => {
                const star = <Icon name="star" solid size={size} color={i <= rating ? "accent" : "border"} />
                if (onRate == null) return <React.Fragment key={i}>{star}</React.Fragment>
                return (
                    <Pressable
                        key={i}
                        onPress={() => onRate(i)}
                        accessibilityRole="radio"
                        accessibilityState={{ selected: i === rating }}
                        accessibilityLabel={starLabel(i)}
                    >
                        {star}
                    </Pressable>
                )
            })}
        </Row>
    )
}
